module.exports = __webpack_public_path__ + "static/media/icon_177.16e2d775.svg";